import { render, staticRenderFns } from "./groupResult.vue?vue&type=template&id=24811336&scoped=true"
import script from "./groupResult.vue?vue&type=script&lang=js"
export * from "./groupResult.vue?vue&type=script&lang=js"
import style0 from "./groupResult.vue?vue&type=style&index=0&id=24811336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24811336",
  null
  
)

export default component.exports